export const defaultAddress = {
    street: "",
    city: "",
    stateId: "",
    countryId: "",
    zipCode: ""
};

export const defaultPayer = {
    name: "",
    address: {...defaultAddress},
    sapCode: "",
    taxNumber: "",
    vatNumber: "",
    bankIBAN: "",
    swiftBic: "",
    sdiCode: "",
    phone: "",
    mail: ""
};

export const defaultBilling = {
    name: "",
    address: {...defaultAddress},
    sapCode: "",
    taxNumber: "",
    vatNumber: "",
    sdiCode: "",
    phone: "",
    mail: ""
};

export const defaultBankReference = {
    name: "",
    address: {...defaultAddress},
    account: "",
    email: "",
    phone: "",
    fax: ""
};

export const defaultContact = {
    name: "",
    email: "",
    phone: ""
};

export const defaultOrder = {
    firstBuyValue: -1,
    currencyId: "",
    paymentTermId: "",
    specialConditions: "",
    hasCreditLetter: false,
    attachments: [],
    isPayerDifferentFromClient: false,
    payer: {...defaultPayer},
    isBillingDifferentFromClient: false,
    billing: {...defaultBilling},
    hasMultiBranchContract: false
};

export const defaultInvoiceAddress = {
    shipName: "",
    address: {...defaultAddress},
    email: "",
    phoneFax: "",
    taxNumber: "",
    vatNumber: ""
};

export const defaultMargins = {
    jewellery: 0,
    watches: 0,
    accessories: 0,
    hewMargin: 0,
    hjMargin: 0,
    perfume: 0,
    perfumesKit: 0
};

export const defaultCustomerRequest = {
    ownerKey: null,
    ownerFullName: null,
    customerName: "",
    primaryAddress: { ...defaultAddress },
    hasSecondaryAddress: false,
    secondaryAddress: { ...defaultAddress },
    contacts: [{...defaultContact}],
    hasVatNumber: false,
    vatNumber: "",
    taxNumber:"",
    parentBeneficialOwner: "",
    affiliates: "",
    principalOperationCountryId: "",
    chainId: "",
    isExistingCustomer: false,
    customerSapCode: "",
    masterCode: "",
    bankName: "",
    bankIBAN: "",
    swiftBic: "",
    bankReferences: [{...defaultBankReference}],
    salesGroupId: "",
    responsibilityAreaId: "",
    companyId: "",
    salesOrganizationId: "",
    salesOfficeId: "",
    businessCategoryId: "",
    customerGroupId: "",
    customerGroup6Id: "",
    customerGroup7Id: "",
    customerGroup8Id: "",
    customerGroup9Id: "",
    customerGroup10Id: "",
    distributionChannelId: "",
    salesDistrictId: "",
    royaltiesPercentage: 0,
    marketingContributionPercentage: 0,
    briefPresentation: "",
    yearlySalesBudget: -1,
    customerCurrencyId: "",
    invoiceCurrencyId: "",
    order: {...defaultOrder},
    incotermsId: "",
    incotermsLocation: "",
    shipAddress: "",
    purchasingContact:"",
    warehouseContact:"",
    administrationContact:"",
    additionalShippingDoc: "",
    shippingDocs: [],
    preferredTransportMode: "",
    deliveryDateMandatoryId: "",
    acceptBackOrders: false,
    additionalShippingInfo: "",
    cities: "",
    fire: false,
    transportationZoneId: "",
    shippingConditionsId: "",    
    isInvoceAddressDifferentFromCustomer: false,    
    invoiceAddresses:[{...defaultInvoiceAddress}],
    resaleMargins: { ...defaultMargins },
    customerMarginNote: "",
    pricingListId: "",
    pricingGroupId: "",
    pricingNote: ""
};

export const defaultRiskEvaluation = {
    creditControlAreaId: "",
    creditLimit: -1,
    globalCreditLimit: -1,
    creditLimitCurrencyId: "",
    ratingId: "",
    sheetInfoDocs: null
};

export const defaultEthicsCompliance = {
    areRedFlags: false,
    isMitigated: false,
    mitigateActions: "",
    mitigationAttachments: []
};

export const defaultCreditManagement = {
    segmentId: "",
    creditTypes: new Array(3).fill(null).map(() => ({
        infoTypeId: "",
        import: undefined,
        currencyId: "",
        endOfValidity: null
    }))
};

export const defaultPricingUnit = {
    pricingListId: "",
    pricingGroupId: ""
};

export const defaultAccountReceivable = {
    accountAssignmentGroupId: "",
    cashManagementGroupId: "",
    reconcilationAccountId: "",
    sortKeyId: "",
    accountingClerkId: "",
    dummyProcedureId: "",
    deliveringPlantId: "",
    taxCategories : []
};

export const defaultTaxCategory = {
    taxCategoryName: "",
    taxClassification: "",
    countryKey: ""
};

export const defualtLogisticDoc = {
    transportationZoneId: "",
    incotermsId: "",
    incotermsLocation: ""
};

export const defualtLogisticCuSrv = {
    customerTypeId: "",
    shippingConditionsId: "",
    //numberFunctionPartnerSP: "",
    forwardingAgent: ""
};

export const defualtLogisticPlan = {
    deliveryPriorityId: "",
    requestedDeliveryDateId: "",    
    acceptBackOrders: false,
    cG4Id: ""
};